export const services = [
  {
    id: 1,
    slug: "dental-implants",
    name: "Dental Implants",
    shortName: "Implants",
    image: "/images/s3.png",
    imageAlt: "Dental Implant Treatment at Olive Dental Clinic",
    description: "Permanent replacement for missing teeth using advanced dental implant technology.",
    keywords: ["Dental Implants", "Missing Teeth", "Implant Dentistry"],
    color: "from-purple-500 to-pink-500",
    bgHover: "hover:bg-purple-50",
    featured: true
  },
  {
    id: 2,
    slug: "root-canal-treatment",
    name: "Root Canal Treatment",
    shortName: "Root Canal",
    image: "/images/s2.png",
    imageAlt: "Root Canal Treatment at Olive Dental Clinic",
    description: "Advanced painless root canal treatment to save infected teeth and eliminate dental pain.",
    keywords: ["Root Canal", "RCT", "Endodontic Treatment"],
    color: "from-green-500 to-emerald-500",
    bgHover: "hover:bg-green-50",
    featured: true
  },
  {
    id: 3,
    slug: "teeth-whitening",
    name: "Teeth Whitening",
    shortName: "Whitening",
    image: "/images/s1.png",
    imageAlt: "Professional Teeth Whitening at Olive Dental Clinic",
    description: "Professional teeth whitening treatment to safely remove stains and restore a brighter, more confident smile.",
    keywords: ["Teeth Whitening", "Laser Teeth Whitening", "Smile Whitening"],
    color: "from-blue-500 to-cyan-500",
    bgHover: "hover:bg-blue-50",
    featured: true
  },
  {
    id: 4,
    slug: "aligners",
    name: "Aligners",
    shortName: "Aligners",
    image: "/images/s5.png",
    imageAlt: "Clear Aligners at Olive Dental Clinic",
    description: "Clear aligners for comfortable and nearly invisible teeth straightening.",
    keywords: ["Aligners", "Invisible Braces", "Clear Aligners"],
    color: "from-indigo-500 to-purple-500",
    bgHover: "hover:bg-indigo-50",
    featured: true
  },
  {
    id: 5,
    slug: "teeth-cleaning",
    name: "Teeth Cleaning",
    shortName: "Cleaning",
    image: "/images/s4.png",
    imageAlt: "Professional Teeth Cleaning at Olive Dental Clinic",
    description: "Professional scaling and polishing to maintain healthy teeth and gums.",
    keywords: ["Teeth Cleaning", "Scaling", "Polishing"],
    color: "from-teal-500 to-cyan-500",
    bgHover: "hover:bg-teal-50",
    featured: true
  },
  {
    id: 6,
    slug: "tooth-extraction",
    name: "Tooth Extraction",
    shortName: "Extraction",
    image: "/images/s6.png",
    imageAlt: "Painless Tooth Extraction at Olive Dental Clinic",
    description: "Safe and painless tooth extraction performed using modern techniques.",
    keywords: ["Tooth Extraction", "Wisdom Tooth", "Dental Surgery"],
    color: "from-red-500 to-orange-500",
    bgHover: "hover:bg-red-50",
    featured: false
  },
  {
    id: 7,
    slug: "veneers",
    name: "Veneers",
    shortName: "Veneers",
    image: "/images/s7.png",
    imageAlt: "Dental Veneers at Olive Dental Clinic",
    description: "Premium veneers designed to improve the appearance of your smile.",
    keywords: ["Veneers", "Smile Makeover", "Cosmetic Dentistry"],
    color: "from-pink-500 to-rose-500",
    bgHover: "hover:bg-pink-50",
    featured: false
  },
  {
    id: 8,
    slug: "orthodontic-treatment",
    name: "Orthodontic Treatment",
    shortName: "Orthodontics",
    image: "/images/s9.png",
    imageAlt: "Orthodontic Treatment at Olive Dental Clinic",
    description: "Orthodontic treatment for correcting teeth alignment and bite problems.",
    keywords: ["Braces", "Orthodontics", "Teeth Alignment"],
    color: "from-yellow-500 to-amber-500",
    bgHover: "hover:bg-yellow-50",
    featured: false
  },
  {
    id: 9,
    slug: "kids-dental-treatment",
    name: "Kids Dental Treatment",
    shortName: "Kids Dentistry",
    image: "/images/s11.png",
    imageAlt: "Children's Dental Care at Olive Dental Clinic",
    description: "Friendly pediatric dental care for infants, children and teenagers.",
    keywords: ["Kids Dentist", "Children Dentist", "Pediatric Dentistry"],
    color: "from-pink-500 to-rose-500",
    bgHover: "hover:bg-pink-50",
    featured: false
  },
  {
    id: 10,
    slug: "preventive-care",
    name: "Preventive Care",
    shortName: "Prevention",
    image: "/images/s8.png",
    imageAlt: "Preventive Dental Care at Olive Dental Clinic",
    description: "Routine dental examinations and preventive care to maintain long-term oral health.",
    keywords: ["Preventive Dentistry", "Dental Checkup", "Oral Health"],
    color: "from-orange-500 to-red-500",
    bgHover: "hover:bg-orange-50",
    featured: false
  },
  {
    id: 11,
    slug: "digital-xray",
    name: "Digital X-Ray",
    shortName: "Digital X-Ray",
    image: "/images/s10.png",
    imageAlt: "Digital Dental X-Ray at Olive Dental Clinic",
    description: "Low-radiation digital X-rays for accurate diagnosis and treatment planning.",
    keywords: ["Digital X-Ray", "Dental Imaging", "Dental Diagnosis"],
    color: "from-gray-500 to-slate-500",
    bgHover: "hover:bg-gray-50",
    featured: false
  },
  {
    id: 12,
    slug: "surgical-procedures",
    name: "Surgical Procedures",
    shortName: "Surgery",
    image: "/images/s12.png",
    imageAlt: "Oral Surgical Procedures at Olive Dental Clinic",
    description: "Advanced minor oral surgical procedures performed with precision and patient comfort.",
    keywords: ["Oral Surgery", "Dental Surgery"],
    color: "from-red-500 to-rose-500",
    bgHover: "hover:bg-red-50",
    featured: false
  },
  {
    id: 13,
    slug: "general-dentistry",
    name: "General Dentistry",
    shortName: "General",
    image: "/images/s13.png",
    imageAlt: "General Dentistry at Olive Dental Clinic",
    description: "Comprehensive dental care for patients of all ages including diagnosis, prevention and treatment.",
    keywords: ["General Dentistry", "Family Dentist", "Dental Care"],
    color: "from-teal-500 to-emerald-500",
    bgHover: "hover:bg-teal-50",
    featured: false
  }
];

// Helper Functions
export const getServiceBySlug = (slug) =>
  services.find((service) => service.slug === slug);

export const getFeaturedServices = () =>
  services.filter((service) => service.featured);

export const getAllServiceNames = () =>
  services.map((service) => service.name);

export const getAllServiceKeywords = () =>
  [...new Set(services.flatMap((service) => service.keywords))];

export const getServicesByKeyword = (keyword) =>
  services.filter((service) =>
    service.keywords.some((k) => k.toLowerCase().includes(keyword.toLowerCase()))
  );

export const getServiceById = (id) =>
  services.find((service) => service.id === id);